import { HeadModul, ModulContainer } from 'components/Main/table/TableStyles';
import { Modal } from './Header/AddCampaignModal';
import { IoMdClose } from 'react-icons/io';
import { FormInputContainer } from './Header/FormInput';
import { useCampaignContext } from 'context/CampaignContext';
import DatePicker, { registerLocale } from 'react-datepicker';
import { DarkButton } from 'components/style/Global';
import { useState } from 'react';
import { useSaveCustomReports, useUpdateCustomReports } from './Main/OrganisationReport';
import { useCampaignPeriodId } from 'customHooks/useParameters';

type Props = {
  setAddCampaignPeriodModal: (value: boolean) => void;
};

export type CampaignPeriodValues = {
  customReportName: string;
  startDate?: string;
  endDate?: string;
  campaigns?: any[];
  clientCode?: string;
};

const AddCampaignPeriodModal = (props: Props) => {
  const { setAddCampaignPeriodModal } = props;
  const { activeCampaign } = useCampaignContext();

  const [values, setValues] = useState<CampaignPeriodValues>({
    customReportName: '',
    startDate: activeCampaign?.startDate as string,
    endDate: activeCampaign?.endDate as string,
  });

  const [showMessage, setShowMessage] = useState<{ type: 'success' | 'error'; text: string } | null>(null);

  const handleSelectChangeAndUpdateGlobal = (selectedOption: any, accessorKey: string) => {
    const value = selectedOption ? (selectedOption.label ? selectedOption.label : selectedOption) : '';

    setValues({
      ...values,
      [accessorKey]: value,
    });
  };
  const [addCustomReport] = useSaveCustomReports();

  return (
    <Modal style={{ zIndex: 1000 }}>
      <HeadModul style={{ height: 'fit-content' }}>
        <button type="button" className="x" onClick={() => setAddCampaignPeriodModal(false)}>
          {' '}
          <IoMdClose className="closeIcon" />
        </button>
        <ModulContainer>
          <h1>Add Campaign Period</h1>
          <ModulContainer>
            {/* Text Input for Custom Report Name */}
            <FormInputContainer>
              <label htmlFor="customReportName">Custom Report Name</label>
              <input
                type="text"
                id="customReportName"
                name="customReportName"
                placeholder="Enter custom report name"
                style={{ width: '100%', padding: '0.5rem' }}
                value={values['customReportName'] || ''}
                onChange={(e) => handleSelectChangeAndUpdateGlobal(e.target.value, 'customReportName')}
                autoComplete="off"
                autoCorrect="off"
                autoCapitalize="none"
                spellCheck="false"
              />
            </FormInputContainer>

            {/* Date Picker for Start Date and End Date */}
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: '1rem', marginBottom: '1rem' }}>
              <FormInputContainer style={{ width: 'fit-content' }}>
                <label htmlFor="startDate">Start Date</label>
                <DatePicker
                  style={{ width: '100%' }}
                  dateFormat="dd-MM-yyyy"
                  selected={
                    Object.keys(values).some((key) => key === 'startDate')
                      ? values['startDate']
                      : new Date(activeCampaign?.startDate as string)
                  }
                  onChange={(selectedOption: any) =>
                    handleSelectChangeAndUpdateGlobal(selectedOption.toISOString().slice(0, 10), 'startDate')
                  }
                  calendarStartDay={1}
                  minDate={new Date(activeCampaign?.startDate as string)}
                  maxDate={new Date(activeCampaign?.endDate as string)}
                />
              </FormInputContainer>
              <FormInputContainer style={{ width: 'fit-content' }}>
                <label htmlFor="endDate">End Date</label>
                <DatePicker
                  style={{ width: '100%' }}
                  dateFormat="dd-MM-yyyy"
                  selected={
                    Object.keys(values).some((key) => key === 'endDate')
                      ? values['endDate']
                      : new Date(activeCampaign?.endDate as string)
                  }
                  onChange={(selectedOption: any) =>
                    handleSelectChangeAndUpdateGlobal(selectedOption.toISOString().slice(0, 10), 'endDate')
                  }
                  calendarStartDay={1}
                  minDate={new Date(activeCampaign?.startDate as string)}
                  maxDate={new Date(activeCampaign?.endDate as string)}
                />
              </FormInputContainer>
            </div>
          </ModulContainer>

          {/* Success/Error Message */}
          {showMessage && (
            <div
              style={{
                padding: '1rem',
                borderRadius: '4px',
                margin: '1rem 0',
                backgroundColor: showMessage.type === 'success' ? '#d4edda' : '#f8d7da',
                color: showMessage.type === 'success' ? '#155724' : '#721c24',
                border: `1px solid ${showMessage.type === 'success' ? '#c3e6cb' : '#f5c6cb'}`,
                textAlign: 'center',
              }}
            >
              {showMessage.text}
            </div>
          )}

          <div className="buttonsContainer" style={{ alignSelf: 'center' }}>
            {!showMessage && (
              <>
                <button style={{ marginRight: '.4vw' }} type="button" onClick={() => setAddCampaignPeriodModal(false)}>
                  Cancel
                </button>
                <DarkButton
                  type="button"
                  onClick={() => {
                    addCustomReport(values).then((res) => {
                      if (res) {
                        console.log('RES', res);
                        setShowMessage({ type: 'success', text: 'Custom report successfully added!' });
                        // Optional: Auto close modal after 2 seconds
                        setTimeout(() => {
                          setAddCampaignPeriodModal(false);
                          window.location.reload();
                        }, 2000);
                      } else {
                        setShowMessage({ type: 'error', text: 'Failed to add custom report. Please try again.' });
                      }
                    });
                  }}
                >
                  Save
                </DarkButton>
              </>
            )}
            {showMessage && (
              <DarkButton type="button" onClick={() => setAddCampaignPeriodModal(false)}>
                Close
              </DarkButton>
            )}
          </div>
        </ModulContainer>
      </HeadModul>
    </Modal>
  );
};

export default AddCampaignPeriodModal;

type EditProps = {
  setEditModal: (value: boolean) => void;
};
export const EditCampaignPeriodModal = (props: EditProps) => {
  const { setEditModal } = props;
  const [campaignPeriod, ,] = useCampaignPeriodId();
  const { activeCampaign } = useCampaignContext();

  const [values, setValues] = useState<{
    customReportName?: string;
    startDate?: string;
    endDate?: string;
  }>({
    customReportName: activeCampaign?.campaignPeriods?.find((e) => e?.CustomReportID === Number(campaignPeriod))
      ?.CustomReportName,
    startDate: activeCampaign?.campaignPeriods?.find((e) => e?.CustomReportID === Number(campaignPeriod))
      ?.StartDate as string,
    endDate: activeCampaign?.campaignPeriods?.find((e) => e?.CustomReportID === Number(campaignPeriod))
      ?.EndDate as string,
  });
  const [updateCustomRep] = useUpdateCustomReports();
  console.log('values', values);

  return (
    <Modal>
      <HeadModul>
        <button type="button" className="x" onClick={() => setEditModal(false)}>
          {' '}
          <IoMdClose className="closeIcon" />
        </button>

        <ModulContainer>
          <h1>Edit Custom Report</h1>
          <FormInputContainer>
            <label htmlFor="customReportName">Custom Report Name</label>
            <input
              type="text"
              id="customReportName"
              name="customReportName"
              placeholder="Enter custom report name"
              style={{ width: '100%', padding: '0.5rem' }}
              value={
                values?.customReportName ||
                activeCampaign?.campaignPeriods?.find((e) => e?.CustomReportID === Number(campaignPeriod))
                  ?.CustomReportName
              }
              onChange={(e) => setValues({ ...values, customReportName: e.target.value })}
              autoComplete="off"
              autoCorrect="off"
              autoCapitalize="none"
              spellCheck="false"
            />
          </FormInputContainer>
          {/* Date Picker for Start Date and End Date */}
          <div style={{ display: 'flex', justifyContent: 'space-between', gap: '1rem', marginBottom: '1rem' }}>
            <FormInputContainer style={{ width: 'fit-content' }}>
              <label htmlFor="startDate">Start Date</label>

              <DatePicker
                style={{ width: '100%' }}
                dateFormat="dd-MM-yyyy"
                // selected={customReportsList?.find((e) => e?.CustomReportID === Number(campaignPeriod))?.startDate}
                selected={values.startDate}
                onChange={(selectedOption: any) =>
                  setValues({ ...values, startDate: selectedOption.toISOString().slice(0, 10) })
                }
                calendarStartDay={1}
                minDate={new Date(activeCampaign?.startDate as string)}
                maxDate={new Date(activeCampaign?.endDate as string)}
              />
            </FormInputContainer>
            <FormInputContainer style={{ width: 'fit-content' }}>
              <label htmlFor="endDate">End Date</label>

              <DatePicker
                style={{ width: '100%' }}
                dateFormat="dd-MM-yyyy"
                selected={values.endDate}
                onChange={(selectedOption: any) =>
                  setValues({ ...values, endDate: selectedOption.toISOString().slice(0, 10) })
                }
                calendarStartDay={1}
                minDate={new Date(activeCampaign?.startDate as string)}
                maxDate={new Date(activeCampaign?.endDate as string)}
              />
            </FormInputContainer>
          </div>

          <div className="buttonsContainer" style={{ alignSelf: 'center' }}>
            <button style={{ marginRight: '.4vw' }} type="button" onClick={() => setEditModal(false)}>
              Cancel
            </button>
            <DarkButton
              type="button"
              onClick={() => {
                updateCustomRep(values).then((res) => {
                  if (res) {
                    window.location.reload();
                  } else {
                    alert('Failed to edit custom report');
                  }
                });
              }}
            >
              Save
            </DarkButton>
          </div>
        </ModulContainer>
      </HeadModul>
    </Modal>
  );
};
